import React from 'react'
import { array, string } from 'prop-types'
import { Link } from 'gatsby'
import { css } from '@emotion/react'

const productDomain = process.env.GATSBY_PRODUCT_WEBSITE_URL_FOR_FOOTER

const columnCss = css({
  fontSize: '16px',
  flexBasis: 'calc(100%/6)',

  '> div': {
    fontWeight: 500,
    marginBottom: '16px',
  },

  '> a': {
    display: 'block',
    color: 'black',
  },

  '> a:hover': {
    textDecoration: 'underline',
  },
})

const Column = ({ label, list, className }) => (
  <div css={columnCss} className={className}>
    <div>{label}</div>
    {list?.map(({ label, route, link, internalRoute, newTab }, i) => {
      return internalRoute ? (
        <Link key={i} to={internalRoute}>
          {label}
        </Link>
      ) : (
        <a
          key={i}
          href={link || productDomain + route}
          target={newTab ? `_blank` : null}
          rel={newTab ? `noreferrer noopener` : null}
        >
          {label}
        </a>
      )
    })}
  </div>
)

Column.propTypes = {
  label: string,
  list: array,
  className: string,
}

export default Column
